export default "__VITE_ASSET__m1b5Uci3__"